import {
  BasicInput,
  FormikAutocomplete,
  FormikInputDate,
  Row
} from '@elotech/components';
import React from 'react';
import { ProcessoService } from 'service';

const SindicanciaSection: React.FC<unknown> = props => {
  return (
    <>
      <Row>
        <FormikInputDate
          name="processoMp.dataPublicacao"
          label="Data Publicação"
          size={3}
        />
      </Row>
      <Row>
        <BasicInput name="processoMp.nome" label="Sindicado" size={4} />
        <FormikAutocomplete
          name="procedimentoOrigem"
          label="Procedimento Origem"
          size={4}
          onSearch={ProcessoService.findAllAutocomplete}
          getOptionLabel={(p: any) =>
            `Tipo:${p.tipo?.descricao} - Número:${p.numero} - Ano:${p.ano}`
          }
        />
        <BasicInput
          name="processoMp.resolucaoInstauradora"
          label="Resolução Instauradora"
          size={4}
        />
      </Row>
    </>
  );
};

export default SindicanciaSection;
